import api from "@/services/api";
import { ApplicationSettings, InsightsSettings } from "./types";

export async function getApplicationSettings(keys: any): Promise<ApplicationSettings> {
    return new Promise((resolve, reject) => {
        api.post("/applicationSettings", keys).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllApplicationSettings(): Promise<ApplicationSettings> {
    return new Promise((resolve, reject) => {
        api.get("/applicationSettings/getAll").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getApplicationSettingsInsights(keys: any): Promise<InsightsSettings> {
    return new Promise((resolve, reject) => {
        api.post("/applicationSettings/insights", keys).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        ).catch(() => { /* we can log the error */ });
    });
}

export async function getLogLevels(): Promise<string> {
    return new Promise((resolve, reject) => {
        api.get("/applicationSettings/logLevels").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateApplicationSettings(applicationSettings: ApplicationSettings): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/applicationSettings", applicationSettings).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getInstanceName(): Promise<string> {
    return new Promise((resolve, reject) => {
        api.get("/applicationSettings/instanceName").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
